// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\Entity.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { BaseEntity } from '../../../../../../libs/com/MetaPattern/Product/IDE/Util/BaseEntity';
import { PipelinePublishTask } from './PipelinePublishTask';
/**
 * 流水线发布应用 实体类
 * 当发布产品的时候，指定流水线发布任务所勾选的应用
 */
export class PipelinePublishApp extends BaseEntity {
  /** 应用唯一标识 : 应用唯一标识 */
  private _appKey: string;

  /** 设置：应用唯一标识 */
  public get appKey() {
    return this._appKey;
  }

  /** 获取：应用唯一标识 */
  public set appKey(value: string) {
    this._appKey = value;
  }

  /** 应用设计期ID : 应用设计期ID */
  private _appDesignId: string;

  /** 设置：应用设计期ID */
  public get appDesignId() {
    return this._appDesignId;
  }

  /** 获取：应用设计期ID */
  public set appDesignId(value: string) {
    this._appDesignId = value;
  }

  /** 发布任务 的ID */
  private _task_ID: string;

  /** 获取：发布任务 的ID */
  public get task_ID() {
    return this._task_ID;
  }

  /** 设置：发布任务 的ID */
  public set task_ID(value: string) {
    this._task_ID = value;
  }

  /** 发布任务  */
  private _task: PipelinePublishTask;

  /** 获取：发布任务  */
  public get task() {
    return this._task;
  }

  /** 设置：发布任务  */
  public set task(value: PipelinePublishTask) {
    this._task = value;
    if (value !== null) {
      this.task_ID = value.id;
    } else {
      this.task_ID = '';
    }
  }

  constructor() {
    super();
    this._appKey = '';
    this._appDesignId = '';
    this._task_ID = '';
    this._task = null;
  }

  /**
   * 将对象进行所有属性值的复制
   * @param element 要复制的对象
   * @param hasReference 是否复制引用实体
   */
  public copyFrom(element: PipelinePublishApp, hasReference: boolean): void {
    if (element != null) {
      super.copyFrom(element, hasReference);
      this.appKey = element.appKey;
      this.appDesignId = element.appDesignId;
      this.task_ID = element.task_ID;
      if (hasReference && element.task !== null) {
        this.task = element.task;
      }
    }
  }

  protected Deserialize(json: any): void {
    super.Deserialize(json);
    // Add self attribute
    this.appKey = json.AppKey;
    this.appDesignId = json.AppDesignId;
    this.task_ID = json.Task_ID;
    // if (json.Task !== null) {
    //   this.task = PipelinePublishTask.Create(json.Task);
    // }
  }

  protected Serialize(json: any): void {
    super.Serialize(json);
    json.AppKey = this.appKey;
    json.AppDesignId = this.appDesignId;
    json.Task_ID = this.task_ID;
  }

  static Create(json: any): PipelinePublishApp {
    const pipelinePublishApp = new PipelinePublishApp();
    pipelinePublishApp.Deserialize(json);
    pipelinePublishApp.json = json;
    return pipelinePublishApp;
  }
}
